import { inject, observer } from "mobx-react";
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import React, { useEffect, useState } from "react";
import moment from "moment";
import CheckboxRenderer from "../../../common/CheckboxRenderer";
import {
  DateFormatter,
  DateTimeFormatter,
} from "../../../common/DateFormatterWithZone";
import { NumericCellEditor } from "../../../common/NumericCellEditor";
import { DecimalCellEditor } from "../../../common/DecimalCellEditor";
import "./gainloss-unitprice-screen.scss";
import RestEndPoint from "../../../common/RestEndPoint";
import { AppConstants } from "../../../common/APIConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExport,
  faPlus,
  faSave,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import GainLossSmartSelect from "./gainloss-smartSelect";

const GainLossUnitpriceScreen = inject("GainLossUnitPriceDataStore")(
  observer((props) => {
    const {
      headerDetails,
      screenRowData,
      hasScreenData,
      screenColumnDefinitions,
      setScreenData,
      getSystemData,
      saveUnitPriceData,
      SystemData,
    } = props.GainLossUnitPriceDataStore;

    const [noOfRows, setNoOfRows] = useState(1);

    const getCurrentScreenParent = () => {
      const parentScreenName = props.path.split("/").pop();
      const parentScreen = props.CommonStore.screenDetails.find(
        (x) => x.screen.name === parentScreenName
      );

      return parentScreen;
    };

    const parentScreen = getCurrentScreenParent();
    let colDef = screenColumnDefinitions["GainLossUnitpriceScreen"];

    const handlePaste = (params) => {
      console.log("copied values", params);
      console.log(screenRowData.UnitPriceData);
      const tempData = screenRowData.UnitPriceData;
      //setRowData([]);
      const idNumber = screenRowData.UnitPriceData.length + 1;
      params.data.map((item, index) =>
        tempData.push({
          id: idNumber + index,
          system: item[0],
          price: item[1],
          effectiveStartDate: item[2],
        })
      );
      console.log(tempData);
      setScreenData(tempData);
      //screenRowData.UnitPriceData = tempData;
      console.log(screenRowData.UnitPriceData);
    };

    const defaultUnitPriceData = {
      gridOptions: {
        //rowSelection: "single",
        //singleClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        //enableRangeSelection: true,
        rowGroupPanelShow: "always",
        suppressContextMenu: true,
        statusBar: {
          statusPanels: [
            {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left",
            },
            {
              statusPanel: "agAggregationComponent",
              statusPanelParams: {
                aggFuncs: ["avg", "count", "min", "max", "sum"],
              },
            },
          ],
        },
        sideBar: {
          toolPanels: [
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
            },
          ],
          showToolPanel: false,
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true,
        },
        frameworkComponents: {
          SmartSelectClearable: GainLossSmartSelect,
          booleanCellEditor: CheckboxRenderer,
          numericCellEditor: NumericCellEditor,
          decimalCellEditor: DecimalCellEditor,
          dateFormatter: DateFormatter,
          dateTimeFormatter: DateTimeFormatter,
        },
        enableRangeSelection: true,
        //processDataFromClipboard: (params) => handlePaste(params),
      },
      editRowData: "",
      rowSelected: false,
      vendorlistTxt: "",
      monthYearTxt: "",
      isSubmitting: false,
      currentColumnDef: [],
    };

    const [unitPriceData, setUnitPriceData] = useState(defaultUnitPriceData);

    const setColumnDef = async () => {
      const { CommonStore, GainLossUnitPriceDataStore } = props;
      const parentScreenName = props.path.split("/").pop();
      const currentScreen = props.CommonStore.screenDetails.filter(
        (x) => x.screen.name === parentScreenName
      );
      //const currentScreenChildren = getCurrentScreenChildren();
      await GainLossUnitPriceDataStore.setColumnDef(currentScreen, CommonStore);
      await GainLossUnitPriceDataStore.getScreenData(CommonStore);
    };
    const getCurrentScreenChildren = () => {
      const parentScreenName = props.path.split("/").pop();
      const currentScreenChildren = props.CommonStore.screenDetails.filter(
        (x) => x.screen.parent === parentScreenName
      );

      return currentScreenChildren;
    };

    const getCurrentScreenChildrenByNm = (screenName) => {
      const parentScreenName = props.path.split("/").pop();
      const currentScreenChildren = props.CommonStore.screenDetails.filter(
        (x) => x.screen.name === parentScreenName && x.screen.name == screenName
      );

      return currentScreenChildren;
    };

    const getVendorTemplateData = async () => {
      setUnitPriceData({ rowSelected: false, editRowData: "" });
      const { CommonStore, GainLossUnitPriceDataStore } = props;
      const parentScreenName = props.path.split("/").pop();
      const currentScreen = props.CommonStore.screenDetails.filter(
        (x) => x.screen.name === parentScreenName
      );
      await GainLossUnitPriceDataStore.getUnitPriceData(CommonStore);
    };

    const onSelectionChanged = async (e) => {
      const selectedRow = unitPriceData.gridOptions.api.getSelectedRows();
      setUnitPriceData({
        rowSelected: selectedRow.length,
        editRowData: selectedRow[0],
      });
    };

    const handleSave = async () => {
      let unitPriceData = screenRowData.UnitPriceData;

      const isEffectiveDateValid = unitPriceData.every(
        (item) => new Date(item.effectiveStartDate).getDate() === 1
      );

      const existingSystems = SystemData?.map((item) => item.entityName);
      const isSystemDataValid = unitPriceData
        ?.filter((item) => item.isModified)
        .every((item) => existingSystems?.includes(item?.system));

      if (isEffectiveDateValid && isSystemDataValid) {
        const currentDate = new Date().toLocaleString(
          "en-US",
          { hour12: false },
          {
            timeZone: "America/Denver",
            timeZoneName: "short",
          }
        );
        const loggedInUser = RestEndPoint.getCurrentUserName();
        unitPriceData = unitPriceData
          .filter((item) => item.isModified)
          ?.map((item) => ({
            ...item,
            createdBy: item.createdBy ?? loggedInUser,
            createdDate: item.createdDate ?? currentDate,
            updatedBy: item.isNewRow ? "" : loggedInUser,
            updatedDate: item.isNewRow ? "" : currentDate,
          }));

        await saveUnitPriceData(props?.CommonStore, unitPriceData);
        refreshData();
      } else {
        !isEffectiveDateValid &&
          window.toastr.error(
            AppConstants.GAIN_LOSS.UNIT_PRICE_SCREEN.TOAST_MESSAGES
              .EFFECTIVE_START_DATE_ERROR
          );

        !isSystemDataValid &&
          window.toastr.error(
            AppConstants.GAIN_LOSS.UNIT_PRICE_SCREEN.TOAST_MESSAGES
              .INVALID_SYSTEM_ERROR
          );
      }
    };

    const onCellValueChanged = (e) => {
      if (e.newValue !== null && e.oldValue != e.newValue) {
        unitPriceData.gridOptions.api.refreshCells();
      } else {
        e.node.setDataValue(e.colDef.field, e.oldValue);
        unitPriceData.gridOptions.api.refreshCells();
      }
      e.node.setDataValue("isModified", true);
      e.node.data.isModified = true;
      e.node.setDataValue("isNewRow", !e?.node.data.unitPriceId);
      e.node.data.isNewRow = !e?.node.data.unitPriceId;
    };

    const formatExportValues = (params) => {
      switch (params?.column?.colId) {
        case "createdDate":
        case "updatedDate":
          return params?.value
            ? moment(params?.value).format("MM/DD/YYYY h:mm a")
            : "";
        case "effectiveStartDate":
          return params?.value
            ? moment(params?.value).format("MM/DD/YYYY")
            : "";
        default:
          return params?.value;
      }
    };

    const exportToExcel = () => {
      const parentScreenName = props.path.split("/").pop();
      var today = new Date();
      const formattedDate = moment(today).format("YYYYMMDDhhmmss");
      const currentSheet = parentScreenName;
      let fileNameExcelExport =
        currentSheet + "_Export_All_" + formattedDate + "";

      unitPriceData.gridOptions.api.exportDataAsExcel({
        fileName: fileNameExcelExport,
        sheetName: currentSheet,
        processCellCallback: formatExportValues,
      });
    };

    const clearFilters = () => {
      unitPriceData.gridOptions.api.setSortModel(null);
      unitPriceData.gridOptions.api.setFilterModel(null);
      unitPriceData.gridOptions.api.onFilterChanged();
      unitPriceData.gridOptions.columnApi.setPivotColumns([]);
      unitPriceData.gridOptions.columnApi.setPivotMode(false);
    };

    const refreshData = async () => {
      const { CommonStore, GainLossUnitPriceDataStore } = props;
      await GainLossUnitPriceDataStore.getUnitPriceData(CommonStore);
    };

    const handleAddRows = () => {
      clearFilters();
      let rowId = screenRowData.UnitPriceData.length + 1;
      let newRows = [];
      for (let i = 0; i < noOfRows; i++) {
        newRows.push({
          //unitPriceId: rowId,
          system: "",
          price: "",
          effectiveStartDate: "",
          isActive: true,
        });
        rowId++;
      }
      setScreenData([...screenRowData.UnitPriceData, ...newRows]);
    };

    useEffect(() => {
      async function fetchData() {
        await getSystemData();
        await refreshData();
        await setColumnDef();
      }
      fetchData();
    }, []);
    return (
      <div className="unit-price-screen col-md-12">
        <div className="container cb-title-container">
          <h3 className="cb-title">{parentScreen.screen.title}</h3>
        </div>
        <div className="col-md-12"></div>
        {screenRowData.UnitPriceData && (
          <>
            <div className="row">
              <AgGrid
                gridID={"unit-price"}
                gridOptions={unitPriceData.gridOptions}
                columnDefs={colDef}
                rowData={screenRowData.UnitPriceData}
                onCellValueChanged={onCellValueChanged}
              />
            </div>
            <div className="row btn-toolbar pull-right">
              <input
                type="number"
                className="no-of-rows"
                min={1}
                max={100}
                value={noOfRows}
                onChange={(event) => setNoOfRows(event.target.value)}
              />
              <button
                type="button"
                className="btn btn-primary btn-grid active"
                onClick={handleAddRows}
              >
                <FontAwesomeIcon className={"fa-icon"} icon={faPlus} />
                <span>Add row(s)</span>
              </button>
              <button
                type="button"
                className="btn btn-primary btn-grid active"
                onClick={() => {
                  clearFilters();
                  refreshData();
                }}
              >
                <FontAwesomeIcon className={"fa-icon"} icon={faSync} />
                <span>Refresh / Cancel</span>
              </button>
              <button
                type="button"
                className="btn btn-primary btn-grid active"
                onClick={handleSave}
                disabled={!hasScreenData}
              >
                <FontAwesomeIcon className={"fa-icon"} icon={faSave} />
                <span>Save</span>
              </button>
              <button
                type="button"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                disabled={!hasScreenData}
                onClick={exportToExcel}
              >
                <FontAwesomeIcon className={"fa-icon"} icon={faFileExport} />
                <span>Export</span>
              </button>
            </div>
          </>
        )}
      </div>
    );
  })
);

export default GainLossUnitpriceScreen;
